<template>
  <router-link
    to="/"
    :class="['desktop-brand-corner', { 'is-inline': inline }]"
    aria-label="返回首页"
    @click.stop
  >
    <span class="desktop-brand-icon" aria-hidden="true">
      <img :src="logo2Image" alt="" class="desktop-brand-logo" />
    </span>
    <span class="desktop-brand-copy">
      <span class="desktop-brand-name">树苗英语</span>
      <span class="desktop-brand-subtitle">TREE SAPLING</span>
    </span>
  </router-link>
</template>

<script>
import logo2Image from '../assets/logo2.png'

export default {
  props: {
    inline: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logo2Image
    }
  }
}
</script>

<style scoped>
.desktop-brand-corner {
  position: absolute;
  top: var(--brand-corner-top, 8px);
  left: var(--brand-corner-left, 24px);
  z-index: 105;
  min-height: 68px;
  padding: 0;
  background: transparent;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  gap: 16px;
  text-decoration: none;
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.desktop-brand-corner.is-inline {
  position: relative;
  top: auto;
  left: auto;
}

.desktop-brand-corner:hover {
  transform: translateY(-1px);
  opacity: 0.92;
}

.desktop-brand-icon {
  width: 68px;
  height: 68px;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(140, 104, 68, 0.12);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.desktop-brand-logo {
  display: block;
  width: 56px;
  height: 56px;
  object-fit: contain;
}

.desktop-brand-copy {
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.desktop-brand-name {
  color: #2d3436;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: 2px;
  white-space: nowrap;
}

.desktop-brand-subtitle {
  color: #a78b76;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1.8px;
  line-height: 1;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .desktop-brand-corner {
    display: none;
  }
}
</style>
